<template>
	<div class="registro-finalizar">
		<div class="registro-finalizar-container">
			<div class="registro-finalizar-left">
				<div class="tiras-top">
					<div class="tira-azul"></div>
					<div class="tira-roja"></div>
				</div>
				<div class="registro-finalizar-form">
					<router-link :to="{ name: 'home' }" class="logo">
						<img src="../../assets/LogoNacionalTickets.svg" alt="Nacional Tickets">
						<span>Nacional<br>Tickets</span>
					</router-link>
					<h1>¡Último paso!</h1>
					<!-- <img src="../../assets/email-enviado.svg" alt="Email enviado"> -->
					<p>Para finalizar el proceso de registro, debes verificar tu correo electrónico. Te hemos enviado un correo a la casilla que has indicado. Revisa en tu bandeja de entrada o correo no deseado.</p>
					<!-- <a href="#">Volver a enviar</a> -->
					<router-link :to="{name: 'home' }">Inicio</router-link>
				</div>
				<div class="footer">
					<span>Club Nacional de Football © {{ new Date().getFullYear() }}</span>
				</div>
			</div>
			<auth-right></auth-right>
		</div>
	</div>
</template>

<script>
	import AuthRight from '../../components/Shared/AuthRight.vue'

	export default {
		name: 'registro-finalizar',
		data() {
			return {
				
			}
		},
		components: {
			'auth-right': AuthRight
		},
		beforeCreate(){
			window.location.href = process.env.VUE_APP_URL_NACIONALUY;

			// if(this.$store.getters.loggedIn === true){
			// 	this.$router.push({ name: 'home' })
			// }
		}
	}
</script>

<style scoped lang="scss">
	@import '../../styles/typography.scss';
	@import '../../styles/mixins.scss';

	.registro-finalizar{
		height: 100%;
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;

		.registro-finalizar-container{
			width: 100%;
			height: 100vh;
			@include flex(row, space-betweeen, center);
			position: relative;
			padding: 0;

			.registro-finalizar-left{
				position: relative;
				width: 800px;
				height: 100vh;
				padding: 0px 24px;
				margin: 0;
				@include flex(column, space-between, center);

				.registro-finalizar-form{
					margin: 0;
					padding: 0;
					width: 100%;
					max-width: 450px;

					.logo{
						@include flex(row, flex-start, center);
						margin: 0;
						margin-bottom: 15px;
						text-decoration: none;
						color: #c61431;
						max-width: 150px;

						img{
							height: 36px;
							width: auto;
							margin-right: 15px;
						}

						span{
							// font-family: 'Bungee', sans-serif;
							font-size: 17px;
							color: #c61431;
							line-height: 1.2em;
						}

						&:hover{
							text-decoration: none;
						}
					}

					h1{
						font-size: 28px;
						margin: 0;
						margin-top: 15px;
						margin-bottom: 15px;
						font-weight: 300;
						color: #29355c;
						display: inline-block;
					}

					p{
						margin: 10px 0;
						margin-top: 0;
						color: #29355c;
						font-size: 14px;
					}
				}

				.tiras-top{
					height: 50px;
					width: 30px;
					background-color: #fff;
					margin-bottom: 40px;
					@include flex(row, space-between, center);

					.tira-azul{
						background-color: #172e84;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}

					.tira-roja{
						background-color: #c61431;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}
				}

				.footer{
					width: 100%;
					padding: 20px 0;
					@include flex(column, center, center);

					span{
						font-weight: 400;
						font-size: 12px;
						line-height: 1em;
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and (max-width: 1360px){
		.registro-finalizar{
			.registro-finalizar-container{
				.registro-finalizar-left{
					width: 700px;
				}

				.auth-right{
					width: calc(100% - 700px);
				}
			}
		}
	}

	@media screen and (max-width: 1260px){
		.registro-finalizar{
			.registro-finalizar-container{
				.registro-finalizar-left{
					width: 600px;
					
					.registro-finalizar-form{
						max-width: 380px;
					}
				}

				.auth-right{
					width: calc(100% - 600px);
					background-size: auto;
				}
			}
		}
	}

	@media screen and (max-width: 960px){
		.registro-finalizar{
			.registro-finalizar-container{
				.registro-finalizar-left{
					width: 100%;
					
					.registro-finalizar-form{
						max-width: 450px;
					}
				}

				.auth-right{
					display: none;
				}
			}
		}
	}
</style>